<p i18n *ngIf="null === serverStats">Loading instance statistics...</p>

<section *ngIf="null !== serverStats">
  <h3 i18n>By users on this instance</h3>

  <div class="row">
    <div class="col-6 col-lg-4 col-xl-3">
      <div class="card stat">
        <div class="card-body">
          <p class="stat-value">{{ serverStats.totalUsers | number }}</p>
          <p class="stat-label" i18n>users</p>
        </div>
        <my-global-icon iconName="user"></my-global-icon>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-3">
      <div class="card stat">
        <div class="card-body">
          <p class="stat-value">{{ serverStats.totalLocalVideos | number }}</p>
          <p class="stat-label" i18n>videos</p>
        </div>
        <my-global-icon iconName="film"></my-global-icon>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-3">
      <div class="card stat">
        <div class="card-body">
          <p class="stat-value">{{ serverStats.totalLocalVideoViews | number }}</p>
          <p class="stat-label" i18n>views</p>
        </div>
        <my-global-icon iconName="eye-open"></my-global-icon>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-3">
      <div class="card stat">
        <div class="card-body">
          <p class="stat-value">{{ serverStats.totalLocalVideoComments | number }}</p>
          <p class="stat-label" i18n>comments</p>
        </div>
        <my-global-icon iconName="message-circle"></my-global-icon>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-3">
      <div class="card stat">
        <div class="card-body">
          <p class="stat-value">{{ serverStats.totalLocalVideoFilesSize | bytes:1 }}</p>
          <p class="stat-label" i18n>hosted video</p>
        </div>
        <my-global-icon iconName="home"></my-global-icon>
      </div>
    </div>
  </div>

  <h3 i18n>In this instance federation</h3>

  <div class="row">
    <div class="col-6 col-lg-4 col-xl-3">
      <div class="card stat">
        <div class="card-body">
          <p class="stat-value">{{ serverStats.totalVideos | number }}</p>
          <p class="stat-label" i18n>videos</p>
        </div>
        <my-global-icon iconName="film"></my-global-icon>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-3">
      <div class="card stat">
        <div class="card-body">
          <p class="stat-value">{{ serverStats.totalVideoComments | number }}</p>
          <p class="stat-label" i18n>comments</p>
        </div>
        <my-global-icon iconName="message-circle"></my-global-icon>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-3">
      <div class="card stat">
        <div class="card-body">
          <p class="stat-value">{{ serverStats.totalInstanceFollowers | number }}</p>
          <p class="stat-label" i18n>followers</p>
        </div>
        <my-global-icon iconName="share"></my-global-icon>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-3">
      <div class="card stat">
        <div class="card-body">
          <p class="stat-value">{{ serverStats.totalInstanceFollowing | number }}</p>
          <p class="stat-label" i18n>following</p>
        </div>
        <my-global-icon iconName="globe"></my-global-icon>
      </div>
    </div>
  </div>
</section>
